import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core";

// styles
const styles = () => ({
    root: {
        margin: 50,
        padding: 10,
        width: 180,
        fontSize: 20,
        fontWeight: "bold"
    }
});

// Reuseable Button
function CustomButton(props) {
    const {
        disabled,
        startIcon,
        endIcon,
        size,
        color,
        variant,
    } = props;
    return (
        <Button
        disabled={disabled}
        startIcon={startIcon || null}
        endIcon={endIcon || null}
        variant={variant || "contained"}
        color={color || "primary"} {...props}
        size={size}
        classes={{root: "custom_btn_main"}}
        >

            {props.children}
        </Button>)
}

export default withStyles(styles)(CustomButton);